const rtlEnvs = ['ar-']

export default function (locale: string) {
  return !!rtlEnvs.find(language => locale?.includes(language))
}
